import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-attendance-details-grid',
  templateUrl: './attendance-details-grid.component.html',
  styleUrls: ['./attendance-details-grid.component.css']
})
export class AttendanceDetailsGridComponent implements OnInit {

  title="View Attendance Details";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/hrms/payroll/attendance-details/attendance-details-grid/attendance-details-grid.component.ts